// The form holds scheduled fee times as "HH:mm" (native time input); the API
// stores WITA decimal hours where an end time of midnight is 24, never 0.

export const SURGE_MAX_DURATION_MINUTES = 12 * 60;

const pad = value => String(value).padStart(2, '0');

export function hoursToTimeValue(hours) {
    const value = Number(hours);
    if (hours === null || hours === undefined || hours === '' || !Number.isFinite(value)) return '';
    // FLOAT columns come back as e.g. 17.0833, so round to the nearest minute.
    const minutes = Math.round(value * 60) % (24 * 60);
    return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
}

export function timeValueToMinutes(value) {
    const match = /^(\d{2}):(\d{2})/.exec(value || '');
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    return hours < 24 && minutes < 60 ? hours * 60 + minutes : null;
}

export function startTimeValueToHours(value) {
    const minutes = timeValueToMinutes(value);
    return minutes === null ? null : minutes / 60;
}

export function endTimeValueToHours(value) {
    const minutes = timeValueToMinutes(value);
    if (minutes === null) return null;
    return (minutes === 0 ? 24 * 60 : minutes) / 60;
}

// Window length in minutes, wrapping past midnight; 0 when start equals end.
export function surgeDurationMinutes(startValue, endValue) {
    const start = timeValueToMinutes(startValue);
    const end = timeValueToMinutes(endValue);
    if (start === null || end === null) return null;
    return (end - start + 24 * 60) % (24 * 60);
}

export function formatDuration(minutes) {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return [hours && `${hours} hr`, rest && `${rest} min`].filter(Boolean).join(' ');
}
